import { cn } from '@/lib/utils';
import { useTrialDays } from '@/hooks/useSubscription';
import { PLANO_CARDS } from './constants';
import type { PlanoCard } from './types';

interface PlanCardsProps {
  selected: PlanoCard;
  onSelect: (card: PlanoCard) => void;
  disabled?: boolean;
}

// Grid 2x2: Teste N dias | Básico / Profissional | Enterprise.
// Rótulo centralizado, sem ícone (igual ao protótipo). O card selecionado fica
// preenchido — AZUL p/ os 3 padrão, VERDE p/ Enterprise (deriva o tema do modal).
export function PlanCards({ selected, onSelect, disabled }: PlanCardsProps) {
  const { data: trialDays } = useTrialDays();

  return (
    <div className="grid grid-cols-2 gap-3" role="radiogroup" aria-label="Plano">
      {PLANO_CARDS.map(({ card, label }) => {
        const active = card === selected;
        const isEnterprise = card === 'enterprise';
        const displayLabel =
          card === 'trial' && trialDays != null ? `Teste ${trialDays} dias` : label;
        return (
          <button
            key={card}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onSelect(card)}
            className={cn(
              'flex items-center justify-center rounded-xl border px-4 py-3 text-center text-sm font-semibold shadow-card transition-colors disabled:opacity-50',
              active && !isEnterprise && 'border-primary bg-primary text-white',
              active && isEnterprise && 'border-tertiary bg-tertiary text-on-tertiary',
              !active &&
                'border-border bg-bg-elevated text-text-title hover:border-primary/50 hover:bg-primary/5'
            )}
          >
            {displayLabel}
          </button>
        );
      })}
    </div>
  );
}
